<div class="modal fade" id="Validity_Modal" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered modal-md">
    <div class="modal-content dirI">
      <div class="modal-header dirI">
        <h5 class="modal-title" id="exampleModalLabel">ویرایش اعتبار</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <div class="modal-body" [formGroup]="validityForm">
        <p class="valid-hint">پر کردن یکی از دو فیلد زیر الزامی است:</p>
        <div class="row gx-2 gy-2">
          <div class="col-12 col-md-6">
            <div class="valid-field">
              <label>تاریخ پایان اعتبار</label>
              <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false"
                [dateGregorianFormat]="'YYYY/MM/DD'" [dateInitValue]="true"
                [dateFormat]="'jYYYY/jMM/jDD'">
                <input type="text" formControlName="strValidDate" class="form-control" placeholder="۱۴۰۳/۰۵/۱۲" />
              </ng-persian-datepicker>
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="valid-field">
              <label>مبلغ اعتبار (ریال)</label>
              <div class="valid-amount">
                <input class="form-control" inputmode="numeric" appNumericOnly
                  formControlName="iChargingFee" placeholder="مثلاً ۱٬۰۰۰٬۰۰۰">
                <span class="valid-currency">ریال</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer valid-footer">
        <button type="button" class="btn btn-light" data-bs-dismiss="modal">بستن</button>
        <button type="button" class="btn btn-success valid-submit" (click)="submit()">
          <i class="fa fa-refresh"></i> تمدید اعتبار
        </button>
      </div>
    </div>
  </div>
</div>
